import type { Bounds } from "@repo/ui";

import type { MapSettings, PositionViewModel } from "../models/location";
import type { IMapFilter } from "../pages/maps/filters/filterContext";
import { BaseController } from "./baseController";

const controller = import.meta.env.MODE === "development" ? "MVC/Breadcrumbs" : "Breadcrumbs";

export class BreadcrumbsController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static GetPositions = (action: string, params: Partial<IMapFilter>) =>
		BreadcrumbsController.Get<PositionViewModel[]>(action, params);

	public static getLiveView(filters: IMapFilter) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetLiveView", params);
	}

	public static getGeographicView(bounds: Bounds, filters: IMapFilter) {
		const params = {
			...filters,
			...bounds,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetGeographicView", params);
	}

	public static getPositions(filters: IMapFilter) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetPositions", {
			...params,
		});
	}

	public static getSales(filters: IMapFilter) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetSales", {
			...params,
		});
	}

	public static getLeads(filters: IMapFilter) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetLeads", {
			...params,
		});
	}

	public static getRetailLocations(stateIds?: (number | string)[], lastPositions?: string) {
		return BreadcrumbsController.GetPositions("GetRetailLocations", {
			stateIds,
			lastPositions,
		});
	}

	public static getSettings() {
		return BreadcrumbsController.Get<MapSettings>("GetSettings");
	}
}
